import React, {Component} from 'react';
import {Dropdown, Divider} from 'semantic-ui-react';
import axios from 'axios'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown } from '@fortawesome/free-solid-svg-icons'

// const SeeResultsTab = () => <div> see results goes here. </div>

class PollCard extends Component {
    constructor(props) {
        super(props)

        this.state = {
            dropDownClicked: false,


        }
    }

    changeDropDown = () =>{
        this.setState({dropDownClicked: !this.state.dropDownClicked})
    }
    render() {
        
        console.log("inside graph props = ",this.props.item)
        // return <div>test</div>
        const choice = []
        if(this.props.item == undefined) return null;
        for(const i of this.props.item.choices){
            choice.push(<div className="choiceBar">{i.description}</div>) 
        }
        if(this.state.dropDownClicked && this.props.item.question!=undefined){ 
            return (

                <div className="pollContainer">
                    <div className="dropDown" onClick={()=>{this.changeDropDown()}}><FontAwesomeIcon icon={faChevronDown} style={{color: "grey"}} /></div>
                    <div className="question"> {this.props.item.question}</div>
                    <div className="pollChoices">
                        {choice}

                    </div>
                    {/* <div className="pollLikes"> {this.props.item.totalLikes} likes</div> */}
        
        
                </div>
            )
        }
        else{
            if(this.props.item.question!=undefined){
            return (

                <div className="pollContainer" style={{height: "100px"}}>
                    <div className="dropDown" onClick={()=>{this.changeDropDown()}}><FontAwesomeIcon icon={faChevronDown} style={{color: "grey"}} /></div>
                    <div className="question" styel={{marginTop: "-10%"}}> {this.props.item.question}</div>
                    {/* <div className="pollLikes"> {this.props.item.totalLikes} likes</div> */}
        
        
                </div>
            )

        }}
    }
}
export default PollCard;